import { createReducer, on, createFeature } from '@ngrx/store'
import * as StateActions from './state.actions'
import { StateState } from './state.state'

const initialState: StateState = {
  states: [],
  selectedState: null,
  loading: false,
  error: null
}

export const stateReducer = createReducer(
  initialState,
  on(StateActions.loadStates, state => ({ ...state, loading: true })),
  on(StateActions.loadStatesSuccess, (state, { states }) => ({
    ...state,
    states,
    loading: false,
    error: null
  })),
  on(StateActions.loadStateFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(StateActions.clearStates, state => ({
    ...state,
    states: []
  }))
)

// Create the feature for the business state
export const stateFeature = createFeature({
  name: 'state', // Feature name
  reducer: stateReducer
})
export type { StateState }
// Export the feature's selectors
export const { name, reducer, selectStates, selectLoading, selectError } = stateFeature
